import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const links = [
    { to: '/', label: 'Home' },
    { to: '/listen', label: 'Listen' },
    { to: '/live', label: 'Live' },
    { to: '/about', label: 'About' },
    { to: '/press', label: 'Press' },
    { to: '/collaborators', label: 'Collaborators' },
]

const NavBar = () => {
    const [open, setOpen] = useState(false)
    const [scrolled, setScrolled] = useState(false)
    const location = useLocation()

    useEffect(() => {
        setOpen(false)
        window.scrollTo(0, 0)
    }, [location.pathname])

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40)
        onScroll()
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    return (
        <header className={`site-header ${scrolled || open ? 'is-solid' : ''}`}>
            <nav className='nav'>
                <Link to='/' className='nav__brand'>O, Kenayda</Link>
                <button
                    className={`nav__toggle ${open ? 'is-open' : ''}`}
                    aria-label='Menu'
                    aria-expanded={open}
                    aria-controls='nav-links'
                    onClick={() => setOpen(!open)}
                >
                    <span></span><span></span>
                </button>
                <ul id='nav-links' className={`nav__links ${open ? 'is-open' : ''}`}>
                    {links.map((link) => (
                        <li key={link.to}>
                            <NavLink to={link.to} end className='nav__link'>{link.label}</NavLink>
                        </li>
                    ))}
                </ul>
            </nav>
        </header>
    )
}

export default NavBar
